var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7502_5089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08784 15.2468L4.11068 15.0698L5.08784 15.2468C5.19357 14.663 5.22809 14.4938 5.2851 14.3428C5.34228 14.1914 5.41762 14.0475 5.50948 13.9142C5.60107 13.7813 5.7205 13.6565 6.13998 13.2371L14.0696 5.30742C14.3351 5.04196 14.4289 4.94913 14.5077 4.88148C15.6321 3.91523 17.2937 3.91523 18.4181 4.88148C18.4969 4.94913 18.5907 5.04196 18.8562 5.30742C19.1216 5.57289 19.2145 5.66673 19.2821 5.74546C20.2484 6.86989 20.2484 8.5315 19.2821 9.65593C19.2145 9.73466 19.1216 9.82851 18.8562 10.094L10.9265 18.0236C10.507 18.4431 10.3822 18.5625 10.2494 18.6541C10.1161 18.746 9.97221 18.8213 9.82079 18.8785C9.66982 18.9355 9.50056 18.97 8.91683 19.0758L9.09507 20.0597L8.91683 19.0758L7.36334 19.3572C6.58158 19.4988 6.06173 19.5919 5.66731 19.6271C5.27653 19.662 5.1432 19.6241 5.0929 19.6029C4.85295 19.5016 4.662 19.3106 4.56068 19.0707C4.53944 19.0204 4.5016 18.8871 4.53646 18.4963C4.57165 18.1019 4.66483 17.582 4.80644 16.8003L5.08784 15.2468Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1201 6.40234C13.4737 7.69871 14.8879 10.4329 17.7163 10.9985",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7502_5089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.ea0bfff8faadc282b1defc6df32e9d99.svg";
export { ForwardRef as ReactComponent };